module.exports = __webpack_public_path__ + "img/logo-hk.fc64c2df.png";